<template>
  <!-- Current Location -->
  <div
    class="storelocater-col-md-3 storelocater-col-sm-3 text-right storelocator__location rfp-storelocator-tcell"
    :class="{ storelocatorpdp: productPage }"
  >
    <button class="location-btn" @click="handleCurrentLocationButtonClick">
      <img
        v-if="locationIcon && locationIcon.length > 1"
        :src="locationIcon"
        :alt="locationIconAlt"
        class="Rfp-storelocater-image"
        :class="{ 'rfp-storelocator-rtl': enableRtl }"
      />
      <span class="current-location-button-text Rfp-storelocater-current-location">{{
        btnName
      }}</span>
    </button>
  </div>
  <!--  End current location button -->
</template>

<script>
import eventBus from '@refapp/eventbus-js';

/* global google */

/**
 * @module Component/CurrentLocation
 * @desc the CurrentLocation tag implement
 */
export default {
  /**
   * @member {type} name tag name of the component
   * @readonly
   */
  name: 'rfp-storelocator-current-location',
  props: {
    /**
     * @member {string} Button title
     * @desc title of the Button
     */
    btnName: {
      type: String,
      required: true,
    },
    /**
     * @member {string} Button title
     * @desc title of the Button
     */
    locationIcon: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * @member {string} Button title
     * @desc title of the Button
     */
    locationIconAlt: {
      type: String,
      required: false,
      default: '',
    },
    enableRtl: {
      type: Boolean,
      default: false,
    },
    defaultRadius: {
      type: String,
      required: true,
    },
    defaultDistanceMetric: {
      type: String,
      required: true,
    },
    currentLocationTags: {
      type: String,
      default: '',
    },
    iriEnabled: {
      type: Boolean,
      default: true,
    },
  },
  /**
   * @function data
   * @desc init the data when the component mount
   */
  data() {
    return {
      productPage: true,
    };
  },
  /**
   * @function created
   * @desc on mounting,initiate the function
   */
  created() {
    // init the getlocation
    eventBus.on('currentPlace', () => {
      this.getLocation();
    });
    eventBus.on('enablePdp', () => {
      this.productPage = false;
    });
  },
  methods: {
    sendCurrentLocationClickTaggingData(postalCode) {
      if (!this.currentLocationTags) return;

      let taggingData = {};
      try {
        taggingData = JSON.parse(this.currentLocationTags);
      } catch (e) {
        console.error(
          'error/rfp-storelocator-currentLocation#mounted: Invalid JSON for current location tags. ',
          e,
        );
        return;
      }

      if (!taggingData || Object.keys(taggingData).length === 0) return;

      const DEFAULT_ZIP_TEXT = '[zipcode or city]';

      for (const [key, value] of Object.entries(taggingData)) {
        if (value.includes(DEFAULT_ZIP_TEXT)) {
          taggingData[key] = value.replace(DEFAULT_ZIP_TEXT, postalCode);
        } else {
          taggingData[key] = value.toLowerCase();
        }
      }

      window.dataLayer?.push(taggingData);
    },
    /**
     * @function showPosition
     * @desc showPosition get the lat and lon from current location.
     */
    showPosition(position, { isCurrentLocationButtonClick = false } = {}) {
      eventBus.emit('storeMsg');
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;
      const latlon = new google.maps.LatLng(lat, lng);
      const gcode = new google.maps.Geocoder();
      const latLng = {
        lat: lat,
        lon: lng,
        distances: this.defaultRadius,
        distanceTypes: this.defaultDistanceMetric,
      };
      if (!this.iriEnabled) {
        this.emitPositionRelatedEvents(latLng);
      }

      gcode.geocode({ latLng: latlon }, (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK) return;

        const resultWithPostalCode = results.find((result) =>
          result.address_components.some((el) => el.types.includes('postal_code')),
        );
        if (!resultWithPostalCode) return;

        const postalCodeComponent = resultWithPostalCode.address_components.find((el) =>
          el.types.includes('postal_code'),
        );
        if (!postalCodeComponent) return;

        const postalCode = postalCodeComponent.long_name;
        eventBus.emit('postalCode', postalCode);
        if (this.iriEnabled) {
          latLng.zip = postalCode;
          this.emitPositionRelatedEvents(latLng);
        }
        if (isCurrentLocationButtonClick) {
          this.sendCurrentLocationClickTaggingData(postalCode);
        }
      });
    },
    /**
     * @function emitPositionRelatedEvents
     * @desc emitPositionRelatedEvents emit events related to showPosition function call
     */
    emitPositionRelatedEvents(data) {
      eventBus.emit('mapData', data);
      eventBus.emit('invalidMsg');
    },
    /**
     * @function getLocation
     * @desc getLocation display the geographic location of a user or device on a Google map
     */
    getLocation({ isCurrentLocationButtonClick = false } = {}) {
      eventBus.emit('defaultDistanceEmpty');
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((location) => {
          if (window.google) {
            eventBus.emit('Rfp-Geo-Location-Status', true);
            this.showPosition(location, { isCurrentLocationButtonClick });
          }
        });
      } else {
        eventBus.emit('Rfp-Geo-Location-Status', false);
        eventBus.emit('locationMsg');
      }
    },
    handleCurrentLocationButtonClick() {
      this.getLocation({ isCurrentLocationButtonClick: true });
    },
  },
};
</script>
